<template>
  <section class="network_settings">

    <div class="header">
      <h4 class="title">
        {{ translate("device.network_settings.modal") }}
      </h4>
    </div>

    <div class="body">
      <div class="tab">
        <span
            v-if="check_network"
            class="tab_title"
            :class="{ active : block==='NetworkSettings'}"
            @click="selected_block('NetworkSettings')"
        >
          {{translate('device.network_settings.section.settings')}}
        </span>

        <span
            v-if="check_simcards"
            class="tab_title"
            :class="{ active : block==='SimCards'}"
            @click="selected_block('SimCards')"
        >
          {{translate('device.network_settings.section.sim_cards')}}
        </span>

        <span
            v-if="check_wifi"
            class="tab_title"
            :class="{ active : block==='WiFi'}"
            @click="selected_block('WiFi')"
        >
          {{translate('device.network_settings.section.wi-fi')}}
        </span>
      </div>
      <div class="block">
        <NetworkSettings
            v-if="block==='NetworkSettings'"
            :network_settings="settings.network_settings"
            @update_settings="update_network_settings"
        />
        <SimCards
            v-if="block==='SimCards'"
            :network_settings="settings"
            @update_settings="update_settings"
        />
        <WiFi
            v-if="block==='WiFi'"
            :network_settings="settings"
            @update_settings="update_settings"
        />
      </div>
    </div>

    <div class="footer text-center">
      <span
          type="submit"
          class="btn btn-info btn-fill btn-wd marginButton"
          @click.prevent="updateNetworkSettings()"
      >
        {{ translate("save") }}
      </span>

      <span
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
      >
        {{ translate("close_modal") }}
      </span>
    </div>
  </section>
</template>


<script>
import NetworkSettings from "./Tabs/NetworkSettings/Index.vue";
import SimCards from "./Tabs/SimCards/Index.vue";
import WiFi from "./Tabs/WiFi/Index.vue";

export default {
  name: "EditNetworkSettingsModal",
  components: {
    NetworkSettings,
    SimCards,
    WiFi
  },
  props: [
    "device_fid",
    "network_settings"
  ],

  data() {
    return {
      settings: {},
      block: "NetworkSettings"
    };
  },

  computed:{
    stcp_enabled_count() {
      const stcp = this.settings.simcards?.stcp
      if (!stcp) return null

      return Object.values(stcp).filter(Boolean).length
    },

    power_enabled_count() {
      const power = this.settings.simcards?.power
      if (!power) return null

      return Object.values(power).filter(Boolean).length
    },

    isDataValid() {
      const stcpValid =
          this.stcp_enabled_count === null || this.stcp_enabled_count >= 2

      const powerValid =
          this.power_enabled_count === null || this.power_enabled_count >= 2

      return stcpValid && powerValid
    },
    check_wifi(){
      return this.settings.wifi && this.settings.wifi !== null
    },
    check_network(){
      return this.settings.network_settings && this.settings.network_settings !== null
    },
    check_simcards(){
      return this.settings.simcards && this.settings.simcards !== null
    }
  },

  created() {
    this.settings = JSON.parse(JSON.stringify(this.network_settings))
    if (!this.check_network){
      this.block = "SimCards"
    }
  },
  methods: {
    update_network_settings(new_settings){
      this.settings.network_settings = Object.assign(this.settings.network_settings, new_settings)
    },
    update_settings(new_settings){
      this.settings = Object.assign(this.settings, new_settings)
    },
    selected_block(block){
      this.block = block
    },
    cancel() {
      this.$emit("close");
    },
    async updateNetworkSettings() {
      if (!this.isDataValid) {
        if (this.stcp_enabled_count < 2) await this.global_notify('danger', this.translate('device.network_settings.errors.stcp'))
        if (this.power_enabled_count < 2) await this.global_notify('danger', this.translate('device.network_settings.errors.power'))
        return
      }

      const settings = {
        wifi: this.settings.wifi,
        network_settings: this.settings.network_settings ? {...this.settings.network_settings} : this.settings.network_settings,
        simcards: this.settings.simcards
      }
      const network = settings.network_settings
      if (network) {
        if (network.network_type !== 'L3/DHCP' || Number(network.dhcp_configurable) !== 1 || network.dhcp_custom_range == null) {
          delete network.dhcp_custom_range
        } else {
          network.dhcp_custom_range = Number(network.dhcp_custom_range) === 1
        }
        if (network.dhcp_custom_range !== true) {
          delete network.dhcp_start
          delete network.dhcp_end
          delete network.dhcp_mask
        }
        delete network.dhcp_configurable
        delete network.dhcp_interface
      }
      this.$http.v1.updateNetworkSettingsDevice( this.device_fid, settings, (response) => {
        this.global_notify("info", this.translate("network_setting_saved"));
        this.$emit("update", response);
        this.cancel();
      });
    },
  },
};
</script>

<style lang='scss' scoped>

.network_settings{
  .header{
    width: 100%;
    .title{
      margin: 10px 0;
      text-align: center;
    }
  }
  .body{
    padding: 10px;
    .block{
      min-height: 250px;
    }
  }
  .footer{
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
